import { io } from 'socket.io-client'
import { noop } from 'assets/js/error'

let socket = null
let initialized = false
let startTimeout = null

export const state = () => {
  return {
    events: {}
  }
}

export const mutations = {
  ADD_EVENT (state, { eventName, handler }) {
    if (!state.events[eventName]) {
      state.events[eventName] = []
    }

    state.events[eventName].push(handler)
  },
  REMOVE_EVENT (state, { eventName, handler }) {
    if (!state.events[eventName]) {
      return
    }

    const idx = state.events[eventName].indexOf(handler)

    if (idx !== -1) {
      state.events[eventName].splice(idx, 1)
    }
  }
}

export const actions = {
  on ({ commit, dispatch }, data) {
    dispatch('connect')
      .then(() => {
        commit('ADD_EVENT', data)
      })
      .catch(noop)
  },
  off ({ commit }, data) {
    commit('REMOVE_EVENT', data)
  },
  connect ({ rootGetters, state }) {
    if (initialized) {
      return
    }

    initialized = true

    // open the socket io connection
    socket = io('https://socket-hel1-1.own3d.dev', {
      withCredentials: true,
      forceNew: true,
      autoConnect: false,
      reconnection: false,
      timeout: 20000
    })

    // eslint-disable-next-line no-console
    console.debug('[AlertSocket] Creating a new socket connection...')

    const platform = rootGetters['user/platform']

    socket
      .on('connect', () => {
        const roomId = `90a951d1-ea50-4fda-8c4d-275b81f7d219.${platform.platform}.${platform.platform_id}`
        // eslint-disable-next-line no-console
        console.info(`[AlertSocket] Connected into ${roomId}`)
        socket.emit('room', roomId) // join the correct room
      })
      .on('connect_error', (message) => {
        // eslint-disable-next-line no-console
        console.debug('[AlertSocket] Fail to connect to websocket', message?.toString())
      })

    socket.onevent = function ({ type, data: [event, data] }) {
      if (type !== 2) {
        return
      }

      emit(state, event, data)
    }

    socket.io.on('close', (error) => {
      // eslint-disable-next-line no-console
      console.info('[AlertSocket] Disconnected from alert socket.', error?.toString())

      if (startTimeout) {
        window.clearTimeout(startTimeout)
      }

      startTimeout = window.setTimeout(() => {
        socket.connect()
      }, 6000)
    })
    socket.connect()
  }
}

function emit (state, eventName, data) {
  if (eventName !== '*') {
    emit(state, '*', {
      name: eventName,
      event: data
    })
  }

  if (!state.events[eventName]) {
    return
  }

  for (const handler of state.events[eventName]) {
    handler(eventName, data)
  }
}
